import DefaultFormFooter from './DefaultFormFooter';
import OTPFormFooter from './OTPFormFooter';
import generateRender from 'shared/utils/generateRender';

const FormFooter = generateRender({
  default: DefaultFormFooter,
  hri: OTPFormFooter,
  sga: OTPFormFooter,
});

export default FormFooter;
